import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SortTableCellButtons} from '../../../../../shared/models/sort-table/cell-classes';
import {ButtonConfig} from '../../../../../shared/models/button';
import {OptionGroupMultiSelect} from '../../../../../shared/models/option';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {PopoverSelectHubsComponent} from '../../../popover-multi-select/object-types/hubs/popover-select-hubs.component';
import {PopoverSelectAppsComponent} from '../../../popover-multi-select/object-types/apps/popover-select-apps.component';
import {PopoverMultiSelectComponent} from '../../../popover-multi-select/popover-multi-select.component';
import {PopoverMenuComponent} from '../../../popover-menu/popover-menu.component';
import {RouterLink} from '@angular/router';
import {NgClass} from '@angular/common';
import {SpinnerComponent} from '../../../spinner/spinner.component';

@Component({
  selector: 'motn-sort-table-cell-buttons',
  template: `
    @for (button of cell.buttons; track button.id) {
      @if (!button.href) {
        <button
          [ngClass]="getCssClasses(button)"
          (click)="click(button)"
          [class.loading]="button.loading"
        >
          <span [class.invisible]="button.loading">{{ button.text }}</span>
          @if (button.loading) {
            <motn-spinner></motn-spinner>
          }
        </button>
      }

      @if (button.href) {
        <a [routerLink]="button.href">
          <button
            [ngClass]="getCssClasses(button)"
            (click)="click(button)"
            [class.loading]="button.loading"
          >
            <span [class.invisible]="button.loading">{{ button.text }}</span>
            @if (button.loading) {
              <motn-spinner></motn-spinner>
            }
          </button>
        </a>
      }

      @if (openMenuButtonId === button.id) {
        @if (!button.multiselect) {
          <motn-popover-menu
            [optionGroup]="button.menu"
            (clickedAnywhere$)="closeMenu()"
          ></motn-popover-menu>
        }

        @if (button.multiselect) {
          @if (!button.multiselect?.objectType) {
            <motn-popover-multi-select
              (ready$)="multiselectReady(button, $event)"
              (clickedOption$)="clickedOptionMultiselect(button)"
              (clickedOutsideMenu$)="clickedOutsideMultiselect(button)"
            ></motn-popover-multi-select>
          }

          @if (button.multiselect?.objectType?.apps?.enabled) {
            <motn-popover-select-apps
              [preselectAppsWithTileId]="$safeNavigationMigration(button.multiselect?.objectType?.apps?.preselectAppsWithTileId)"
              (ready$)="multiselectReady(button, $event)"
              (clickedOption$)="clickedOptionMultiselect(button)"
              (clickedOutsideMenu$)="clickedOutsideMultiselect(button)"
            ></motn-popover-select-apps>
          }

          @if (button.multiselect?.objectType?.hubs?.enabled) {
            <motn-popover-select-hubs
              (ready$)="multiselectReady(button, $event)"
              (clickedOption$)="clickedOptionMultiselect(button)"
              (clickedOutsideMenu$)="clickedOutsideMultiselect(button)"
            ></motn-popover-select-hubs>
          }
        }
      }
    }
  `,
  styleUrls: ['./sort-table-cell-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverSelectHubsComponent,
    PopoverSelectAppsComponent,
    PopoverMultiSelectComponent,
    PopoverMenuComponent,
    RouterLink,
    NgClass,
    SpinnerComponent,
  ],
})
export class SortTableCellButtonsComponent extends BaseCellComponent implements OnInit {
  @Input() cell: SortTableCellButtons;

  openMenuButtonId: string;


  constructor() {
    super();
  }

  getCssClasses(button: ButtonConfig): string[] {
    const classes: string[] = ['white'];

    if (button.colors) {
      classes.push(...button.colors);
    }

    if (button.size !== 'normal') {
      classes.push('small');
    }

    return classes;
  }


  closeMenu() {
    this.openMenuButtonId = '';
  }


  multiselectReady(button: ButtonConfig, og: OptionGroupMultiSelect) {
    if (button.multiselect.onReady) {
      button.multiselect.onReady(og);
    }
  }


  clickedOptionMultiselect(button: ButtonConfig) {
    if (button.multiselect.onClickedOption) {
      button.multiselect.onClickedOption();
    }
  }


  clickedOutsideMultiselect(button: ButtonConfig) {
    if (button.multiselect.onClickedOutside) {
      button.multiselect.onClickedOutside();
    }

    this.closeMenu();
  }


  click(button: ButtonConfig) {
    if (button.multiselect || button.menu) {
      this.openMenuButtonId = button.id;
    } else if (button.callback) {
      button.callback();
    }
  }
}
